/* ========== ~~~~~~~~~~ EXPANDABLE SECTION WITH CTA ~~~~~~~~~~ ========== */
import {Button, Section} from "@insticator/insticator-ui";
import React from "react";
import injectSheet from "react-jss";
import styles from "./sectionwithcta_styles"
const SectionWithCTAs = (props) => {
    const {
        isActionProcessing,
        isActionButtonDisabled,
        actionButtonText,
        processingText,
        performAction,
        handleClick,
        normalButtonText,
        ctaIcon,
        children
    } = props;

    return (
      <div className={`${props.classes.expandableSection} ${props.className} sectioncta`}>

          {children && <div className={`content`}>
              {children}
              <Section secondary row>
                  <Button type={'action'} handleClick={performAction} variant={`action`} name={isActionButtonDisabled ? `disableCreation` : `enableCreation`} text={actionButtonText} processing={isActionProcessing} processingText={processingText}/>
                  <Button type={'normal'} text={normalButtonText} variant={'normal'} handleClick={handleClick} icon={ctaIcon}></Button>
              </Section>
          </div>}


     </div>
    )
};

/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(SectionWithCTAs);
